import React from "react";
import T from "prop-types";
import { dollars } from "LIB/formatters/currency";
import {
  DetailTable,
  Detail,
  CheckForDetail
} from "MODULES/shared/components/DetailTable";
import Section from "MODULES/shared/components/Section";
import { renderIf } from "MODULES/shared/decorators";
import {
  CHARGE_NO_FAULT_FOUND_FEE,
  CUSTOMER_RMA_TYPE,
  NO_FAULT_FOUND_FEE,
  NO_FAULT_FOUND_FEE_INVOICED
} from "MODULES/RMAsAndWarranties/constants";
import pojo from "LIB/pojos";
import Form from "./Form";

export function Restocking({ rma }) {
  return [
    <hr key="restocking-dashed-header" className="hr-xs hr-dashed" />,
    <Section
      title="Restocking / No Fault Found Fee"
      key="edit-restocking-modal"
      modal={{
        title: "Edit Restocking Details",
        content: close => (
          <Form
            initialValues={pojo(rma).pick(
              "stock_part",
              "charge_restocking_fee",
              CHARGE_NO_FAULT_FOUND_FEE,
              "restocking_fee",
              "restocking_fee_issued",
              NO_FAULT_FOUND_FEE_INVOICED,
              NO_FAULT_FOUND_FEE
            )}
            close={close}
          />
        )
      }}
    >
      <DetailTable>
        <CheckForDetail label="Stock Part?" value={rma.stock_part} />
        <CheckForDetail
          label="Charge Restocking Fee?"
          value={rma.charge_restocking_fee}
        />
        {rma.charge_restocking_fee && (
          <React.Fragment>
            <Detail
              label="Restocking Fee"
              value={dollars(rma.restocking_fee)}
            />
            <CheckForDetail
              label="Restocking Fee Invoiced?"
              value={rma.restocking_fee_issued}
            />
          </React.Fragment>
        )}
        <CheckForDetail
          label="Charge No Fault Found Fee?"
          value={rma.charge_no_fault_found_fee}
        />
        {rma.charge_no_fault_found_fee && (
          <React.Fragment>
            <Detail
              label="No Fault Found Fee"
              value={dollars(rma.no_fault_found_fee)}
            />
            <CheckForDetail
              label="No Fault Found Fee Invoiced?"
              value={rma.no_fault_found_fee_invoiced}
            />
          </React.Fragment>
        )}
      </DetailTable>
    </Section>
  ];
}

Restocking.propTypes = {
  rma: T.shape({
    stock_part: T.bool,
    charge_restocking_fee: T.bool,
    restocking_fee: T.string,
    restocking_fee_issued: T.bool
  })
};

export default renderIf(
  ({ rma: { type, reference_record_line_item_type: refRecordType } }) =>
    type === CUSTOMER_RMA_TYPE || refRecordType === "PurchaseOrderLineLitem"
)(Restocking);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/Restocking/Restocking.jsx